import { render, staticRenderFns } from "./template-1.vue?vue&type=template&id=455a7522&scoped=true"
import script from "./template-1.vue?vue&type=script&lang=js"
export * from "./template-1.vue?vue&type=script&lang=js"
import style0 from "./template-1.vue?vue&type=style&index=0&id=455a7522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a7522",
  null
  
)

export default component.exports